import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { SellerVtexHistorico } from 'pages/logistica/sellers-vetex/types';

export function useQuerySellersVtexHistorico(idSeller: string) {
    const requestListagem = useRequestListagem();
    const { page, limit, sort } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/sellerhistorico',
        sort: sort.length ? sort : [{ property: 'dhInclusao', direction: 'DESC' }],
        filter: [{ property: 'idSeller', operator: 'eq', value: idSeller, logicalOperator: 'AND' }],
        page,
        limit,
    };

    return useQuery<RequestListagem<SellerVtexHistorico[]>>({
        queryKey: ['seller-vtex-historico', idSeller, requestOptions],
        queryFn: () => requestListagem(requestOptions).then((response) => response.data),
        enabled: Boolean(idSeller),
    });
}
